/*
 * Copyright (c) 2021 JCA Electronics , Winnipeg, MB. All rights reserved.
 */

export enum RosMissionStatus {
  NoMissionLoaded = 0,
  MissionLoaded = 1,
  MissionRunnable = 2,
  MissionRunning = 3,
  MissionCompleted = 4
}
